import View from "../framework/view";
import template from  "../../pugc/wix";
import Server from "../server";
import {Product} from "../bo/product";

export class WixView extends View {

    static classname = "wix-view";

    private server = Server.instance();

    private products? : Product[];

    constructor() {
        super(WixView.classname);
        this.server.getShopProducts().then(products => {
            this.products = products;
            this.update();
        });
    }

    protected render0(): JQuery<HTMLElement> {

        function isEnabled (product: any /* Product */)  {
            const fields = (product.customTextFields || [])
                .map((f: any) => f.title as string)
                .filter((t: string) => t.toLowerCase().indexOf("pick up or delivery date") >= 0);

            return fields.length == 0;
        };

        const data = {
            products: this.products,
            isEnabled: isEnabled
        };
        const out = this.pug(template, data);

        return out;
    }

}
